import type { TextStandardInput } from "./form-types";
import type { StepInputRendererProps } from "./StepInputRenderer";

import { PhoneInputField } from "./PhoneInputField";
import { PostalCodeField } from "./PostalCodeField";
import { SmsOptInField } from "./SmsOptInField";
import { isTextInputType } from "./standard-input-config";
import { TextInputField } from "./TextInputField";

export function StandardInputFormItem({
  input,
  errors,
  onFieldChange,
  onPostalLocationChange,
}: StepInputRendererProps) {
  if (input._type !== "standardInput") {
    return null;
  }

  // Guard against a Sanity document saved mid-edit with no inputType selected
  if (!input.inputType) {
    return null;
  }

  const inputType = input.inputType as string;

  if (inputType === "smsOptIn") {
    return <SmsOptInField onFieldChange={onFieldChange} />;
  }

  if (inputType === "phone") {
    return (
      <PhoneInputField
        errors={errors}
        input={input as TextStandardInput}
        onFieldChange={onFieldChange}
      />
    );
  }

  if (inputType === "postalCode") {
    return (
      <PostalCodeField
        errors={errors}
        input={input as TextStandardInput}
        onFieldChange={onFieldChange}
        onPostalLocationChange={onPostalLocationChange}
      />
    );
  }

  // Defensive guard: unknown inputType — do not crash on unrecognised values.
  if (!isTextInputType(inputType)) {
    return null;
  }

  return (
    <TextInputField
      errors={errors}
      input={input as TextStandardInput}
      onFieldChange={onFieldChange}
    />
  );
}
